/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ZencityComponentDisplay } from "cms/components/components/zencity/display";
import { ZencityComponentEditor } from "cms/components/components/zencity/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

function ZencityComponent (props) {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <ZencityComponentDisplay />,
        editComponent: <ZencityComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
}

ZencityComponent.displayName = "CivilspaceComponent";
export { ZencityComponent };
